/**
 * CORE-Y — "after commitment, the origination method should remain recoverable" (Core-100 R4 W4).
 *
 * `tickets.creation_method` is recorded once (trigger tg_ticket_creation_method; CHECK tickets_creation_method_known)
 * but nothing in the product read it. This is its reader: the Command Center's Details tab says how the ticket came to
 * exist. Every value of the CHECK has words here (a pin asserts the two lists stay equal); NULL means the ticket
 * predates the record, never "typed".
 */
export const TICKET_CREATION_METHODS = [
  'create_ticket', 'document_upload', 'conversation', 'estimate', 'csv_import',
  'ai_intake', 'online_booking', 'rollover', 'structural_change',
] as const;
export type TicketCreationMethod = (typeof TICKET_CREATION_METHODS)[number];

const LABEL: Record<TicketCreationMethod, string> = {
  create_ticket: 'Typed in Create Ticket',
  document_upload: 'Created from an uploaded document (fields extracted, then reviewed)',
  conversation: 'Created from a conversation (fields extracted, then reviewed)',
  estimate: 'Created from an estimate',
  csv_import: 'Imported from a CSV file',
  ai_intake: 'Created from an AI intake draft, approved by a person',
  online_booking: 'Booked online by the customer',
  rollover: 'Continued from the previous day (rollover)',
  structural_change: 'Created by a split or merge of another ticket',
};

export function ticketOriginLabel(method: string | null | undefined): string {
  if (method == null || method === '') return 'Origin not recorded (created before origins were kept)';
  return (LABEL as Record<string, string>)[method] ?? `Origin: ${method}`;
}
